import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="glitter-text"
export default class extends Controller {
  static targets = ["input", "output", "font", "code"]
  static values = { marquee: { type: String, default: 'right' } }

  connect() {
    const max = 140
    const min = 1
    this.font = Math.floor(Math.random() * (max - min + 1)) + min;
    this.generate()
  }

  selectFont({ params }) {
    this.font = params.font
    this.generate()
  }

  toggleMarquee({ params }) {
    this.marqueeValue = params.direction
    this.generate()
  }

  generate() {
    const alphabet = 'abcdefghijklmnopqrstuvwxyz'
    let text = this.inputTarget.value || 'welcome'
    let output = ''
    const marqueOn = this.marqueeValue == 'left' || this.marqueeValue == 'right'

    console.log(this.marqueeValue)
    if (this.marqueeValue == 'left') { output += '<marquee behavior="scroll" direction="left">' }
    if (this.marqueeValue == 'right') { output += '<marquee behavior="scroll" direction="right">' }
    if (marqueOn) {
      output += '<div style="display: flex; width: 100%;">'
    } else {
      output += '<div style="display: flex; width: 100%; justify-content: center;">'
    }

    text.split('').forEach(char => {
      if (alphabet.includes(char.toLowerCase())) {
        output += '<img src="https://media.thuvien.org/alphabet/' + this.font + '/' + char.toLowerCase() + '.gif">'
      } else if (char === ' ') {
        output += '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;'
      }
    })

    output += '</div>'
    if (marqueOn) { output += '</marquee>' }

    this.outputTarget.innerHTML = output
    this.codeTarget.value = output
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
}
